import { render, staticRenderFns } from "./PartnersTable.vue?vue&type=template&id=e85dfda4&"
import script from "./PartnersTable.vue?vue&type=script&lang=js&"
export * from "./PartnersTable.vue?vue&type=script&lang=js&"
import style0 from "./PartnersTable.vue?vue&type=style&index=0&id=e85dfda4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports